import React, { useState } from "react";

const ContactForm = () => {
  const [comment, setComment] = useState("");

  return (
    <section className="font-serif">
      <h2 className="text-3xl font-semibold text-center text-gray-800 mb-2">
        Get In Touch
      </h2>
      <p className="text-center text-gray-500 mb-10">
        Reach out to us & we will respond as soon as we can.
      </p>

      <form className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            type="text"
            placeholder="Full Name:"
            className="border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <input
            type="email"
            placeholder="Email Address:"
            className="border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <input
            type="tel"
            placeholder="Phone Number: 07xx xxx xxx"
            className="border border-gray-300 px-4 py-3 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div>
          <textarea
            placeholder="Leave a comment"
            maxLength={300}
            rows={5}
            className="w-full border border-gray-300 px-4 py-3 rounded resize-none focus:outline-none focus:ring-2 focus:ring-blue-400"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <p className="text-sm text-gray-500 mt-1">
            {comment.length}/300 max characters
          </p>
        </div>

        <div>
          <button
            type="submit"
            className="bg-amber-500 text-white px-8 py-3 rounded hover:bg-gray-800 transition"
          >
            SUBMIT
          </button>
        </div>
      </form>
    </section>
  );
};

export default ContactForm;
